import Collection from '@/components/sections/builder/elements/body/collage/collection';
import { CollageElementDataType } from '@/components/sections/builder/elements/body/collage/type';
import ElementContent from '@/components/sections/builder/elements/body/collage/content';
import ElementSetting from '@/components/sections/builder/elements/body/collage/setting';
import { BetweenHorizontalStart } from 'lucide-react';
import Product from '@/components/sections/builder/elements/body/collage/product';
import Image from '@/components/sections/builder/elements/body/collage/image';

const defaultData: CollageElementDataType = {
  name: 'Collage',
  headingLabel: 'Multimedia collage',
  headingSize: 'small',
  desktopLayout: 'largeLeftBlock',
  mobileLayout: 'collage',
  cardStyle: 'all',
  colorBackgroundScheme: 'background1',
  topPadding: 36,
  bottomPadding: 36,
  contentAlign: 'center',
};

export const ElementPreviewIcon = BetweenHorizontalStart;

const Collage = {
  type: 'collage',
  group: 'body',
  defaultData,
  Element: ElementContent,
  Setting: ElementSetting,
  PreviewIcon: ElementPreviewIcon,
  defaultChilds: [Collection, Product, Image],
  childs: [Collection, Product, Image],
};

export default Collage;
